@if (!renderAsGrid) {
    <nb-accordion
        multi
        class="control-panel-items w-100">
        @for (item of items; track item) {
            <nb-accordion-item
                expanded
                [title]="item.title">
                <nb-accordion-item-header class="d-flex">
                    <div class="d-flex align-items-center">
                        <p class="font-weight-bold mb-0 mr-2">{{ item.title }}</p>
                        <nb-icon
                            icon="info-outline"
                            [nbPopover]="htmlTipComponent"
                            [nbPopoverContext]="{
                                content: item.subtitle
                            }"
                            nbPopoverTrigger="hover"
                            status="basic"></nb-icon>
                    </div>
                </nb-accordion-item-header>
                <nb-accordion-item-body class="p-2">
                    <ng-template
                        kno2ControlPanelItemBody
                        [component]="item.component"
                        [context]="item.context"></ng-template>
                </nb-accordion-item-body>
            </nb-accordion-item>
        }
    </nb-accordion>
}

@if (renderAsGrid) {
    <div class="item-grid control-panel-items w-100 pr-3">
        @for (item of items; track item) {
            <nb-card
                [ngStyle]="item?.styles"
                class="m-0">
                <nb-card-header>
                    <div class="d-flex align-items-center">
                        <p class="font-weight-bold mb-0 mr-2">{{ item.title }}</p>
                        <nb-icon
                            icon="info-outline"
                            [nbPopover]="htmlTipComponent"
                            [nbPopoverContext]="{
                                content: item.subtitle
                            }"
                            nbPopoverTrigger="hover"
                            status="basic"></nb-icon>
                    </div>
                </nb-card-header>
                <nb-card-body>
                    <ng-template
                        kno2ControlPanelItemBody
                        [component]="item.component"
                        [context]="item.context"></ng-template>
                </nb-card-body>
            </nb-card>
        }
    </div>
}
